export enum AuthActionTypes {
    ACTION_LOGIN = 'ACTION_LOGIN',
    ACTION_LOGOUT = 'ACTION_LOGOUT',
    ACTION_REGISTER = 'ACTION_REGISTER',
    ACTION_LOGOUT_LEGACY = 'ACTION_DELETE_TOKEN_LEGACY',
    ACTION_LOGIN_LEGACY = 'ACTION_LOGIN_LEGACY',
  }
  